export const activateResources = {
  zh: {
    'activate.title': '账号激活',
    'activate.step1': '确认账号',
    'activate.step2': '设置密码',
    'activate.step3': '激活完成',

    'activate.step1.welcome': '欢迎使用家庭友好企业 Portal',
    'activate.step1.subtitle': '您正在激活以下企业账号',
    'activate.step1.companyName': '企业名称',
    'activate.step1.companyAccount': '企业账号',
    'activate.step1.email': '关联邮箱',
    'activate.step1.sendCode': '发送验证码到我的邮箱',

    'activate.error.noId': '激活链接无效',
    'activate.error.invalid': '激活码不可用',
    'activate.error.sendCode': '验证码发送失败，请稍后重试',
    'activate.error.activate': '账号激活失败，请稍后重试',

    'activate.step2.codeSentTo': '验证码已发送至',
    'activate.step2.codeLabel': '邮箱验证码',
    'activate.step2.codeValid': '十分钟内有效',
    'activate.step2.spamHint': '邮件可能被误判为垃圾邮件，请留意查看',
    'activate.step2.resendCode': '重新发送验证码',
    'activate.step2.resendCountdown': '重新发送验证码({{seconds}}秒)',
    'activate.step2.passwordLabel': '设置登录密码',
    'activate.step2.passwordPlaceholder': '长度 8-20',
    'activate.step2.passwordHint': '需包含大小写字母、数字、符号中至少 3 类',
    'activate.step2.confirmPasswordLabel': '确认密码',
    'activate.step2.confirmPasswordPlaceholder': '再次输入密码',
    'activate.step2.submit': '激活账号',
    'activate.step2.back': '返回上一步',

    'activate.step3.success': '激活成功',
    'activate.step3.redirecting': '正在为您跳转评选首页 {{seconds}}s...',
    'activate.step3.enterPortal': '立即进入企业中心',
  },
  zh_TW: {
    'activate.title': '帳號激活',
    'activate.step1': '確認帳號',
    'activate.step2': '設置密碼',
    'activate.step3': '激活完成',

    'activate.step1.welcome': '歡迎使用家庭友善企業 Portal',
    'activate.step1.subtitle': '您正在激活以下企業帳號',
    'activate.step1.companyName': '企業名稱',
    'activate.step1.companyAccount': '企業帳號',
    'activate.step1.email': '關聯郵箱',
    'activate.step1.sendCode': '發送驗證碼到我的郵箱',

    'activate.error.noId': '激活連結無效',
    'activate.error.invalid': '激活碼不可用',
    'activate.error.sendCode': '驗證碼發送失敗，請稍後重試',
    'activate.error.activate': '帳號激活失敗，請稍後重試',

    'activate.step2.codeSentTo': '驗證碼已發送至',
    'activate.step2.codeLabel': '郵箱驗證碼',
    'activate.step2.codeValid': '十分鐘內有效',
    'activate.step2.spamHint': '郵件可能被誤判為垃圾郵件，請留意查看',
    'activate.step2.resendCode': '重新發送驗證碼',
    'activate.step2.resendCountdown': '重新發送驗證碼({{seconds}}秒)',
    'activate.step2.passwordLabel': '設置登錄密碼',
    'activate.step2.passwordPlaceholder': '長度 8-20',
    'activate.step2.passwordHint': '需包含大小寫字母、數字、符號中至少 3 類',
    'activate.step2.confirmPasswordLabel': '確認密碼',
    'activate.step2.confirmPasswordPlaceholder': '再次輸入密碼',
    'activate.step2.submit': '激活帳號',
    'activate.step2.back': '返回上一步',

    'activate.step3.success': '激活成功',
    'activate.step3.redirecting': '正在為您跳轉評選首頁 {{seconds}}s...',
    'activate.step3.enterPortal': '立即進入企業中心',
  },
  en: {
    'activate.title': 'Account Activation',
    'activate.step1': 'Confirm Account',
    'activate.step2': 'Set Password',
    'activate.step3': 'Activation Complete',

    'activate.step1.welcome': 'Welcome to Family-Friendly Enterprise Portal',
    'activate.step1.subtitle': 'You are activating the following enterprise account',
    'activate.step1.companyName': 'Company Name',
    'activate.step1.companyAccount': 'Account ID',
    'activate.step1.email': 'Associated Email',
    'activate.step1.sendCode': 'Send Verification Code to My Email',

    'activate.error.noId': 'Invalid activation link',
    'activate.error.invalid': 'Activation code unavailable',
    'activate.error.sendCode': 'Failed to send verification code. Please try again later.',
    'activate.error.activate': 'Account activation failed. Please try again later.',

    'activate.step2.codeSentTo': 'Verification code sent to',
    'activate.step2.codeLabel': 'Email Verification Code',
    'activate.step2.codeValid': 'Valid for 10 minutes',
    'activate.step2.spamHint': 'The email may be marked as spam. Please check your junk folder.',
    'activate.step2.resendCode': 'Resend Code',
    'activate.step2.resendCountdown': 'Resend Code ({{seconds}}s)',
    'activate.step2.passwordLabel': 'Set Login Password',
    'activate.step2.passwordPlaceholder': 'Length 8-20',
    'activate.step2.passwordHint':
      'Must contain at least 3 of: uppercase, lowercase, numbers, symbols',
    'activate.step2.confirmPasswordLabel': 'Confirm Password',
    'activate.step2.confirmPasswordPlaceholder': 'Re-enter password',
    'activate.step2.submit': 'Activate Account',
    'activate.step2.back': 'Go Back',

    'activate.step3.success': 'Activation Successful',
    'activate.step3.redirecting': 'Redirecting in {{seconds}}s...',
    'activate.step3.enterPortal': 'Enter Enterprise Portal',
  },
};
